import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import * as actions from './config.actions';
import { RootState } from '../index';
import { switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConfigEffects {
  initializeAzureMonitoringService: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.CONFIG_GET),
        withLatestFrom(this.store, (action, state) => {
          return { ...state.config };
        }),
        switchMap(({ instrumentationKey, verboseLogging }) => {
          this.azureMonitoringService.init(instrumentationKey, verboseLogging);
          return of(null);
        })
      ),
    { dispatch: false }
  );

  constructor(private store: Store<RootState>, private azureMonitoringService: AzureMonitoringService, private actions$: Actions) {}
}
